module.exports = __webpack_public_path__ + "static/7-272278e36af12fcc1c595bead565cd11.png";